import React,{useState,useEffect,useRef}from 'react'
import { Modal,Form,Input, Radio,App} from 'antd';
import {useYonghuUpdateQuery, useYonghuUpdateSaveMutation,} from '../../store/DianShangYeWuApi';
import Icon from '../../cpn/Icon';
function UserEdit(props) {
    const { message } = App.useApp();
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const onCreateEdit = (values) => {
        // console.log('Received values of form: ', values);
        setOpen(false);
    };
    const [info,setInfo] = useState({
        
    }); 
    const {data,isSuccess} = useYonghuUpdateQuery({yh_id:props.user_id},{skip:!open})
    const editForm = useRef()
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){                
                editForm.current.setFieldsValue({
                    yh_phone:data.Result.yh_phone,
                    yh_name:data.Result.yh_name,
                    yh_qx:data.Result.yh_qx,
                    yh_state:data.Result.yh_state,
                    yh_juese:data.Result.yh_juese,
                    yh_mima:'******',
                })
                setInfo(prevState=>({...prevState,
                    yh_phone:data.Result.yh_phone,
                    user_name:data.Result.yh_name,
                    yh_qx:data.Result.yh_qx,
                    yh_state:data.Result.yh_state,       
                    yh_qy_id:data.Result.yh_qy_id,       
                    yh_juese:data.Result.yh_juese,     
                }))
            }
        }
    },[data,isSuccess])
    const [userEdit] = useYonghuUpdateSaveMutation()
    return (
        <>
            <a onClick={() => {setOpen(true)}}>{props.user_name}</a>
            <Modal
                open={open}
                title='修改操作员'
                okText="保存"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                footer={null}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name={`form_client_edit_${props.yh_id}`}
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 6 }}
                    ref={editForm}

                >                    
                    <Form.Item name="yh_name" wrapperCol={{span:10}} required label='姓名'>                        
                        <Input onChange={(e) => {
                            setInfo(prevState=>({...prevState,user_name:e.target.value}))
                        }}/>
                    </Form.Item>                       
                    <Form.Item name="yh_phone" wrapperCol={{span:10}} required label='登录手机号码'>                        
                        <Input onChange={(e) => {
                            setInfo(prevState=>({...prevState,yh_phone:e.target.value}))
                        }}/>
                    </Form.Item>           
                    <Form.Item name="yh_qx" wrapperCol={{span:10}} required label='权限'>                        
                        <Radio.Group onChange={(e) => {
                            setInfo(prevState=>({...prevState,yh_qx:e.target.value}))
                        }}>
                            <Radio value="业务">业务</Radio>        
                            <Radio value="管理">管理</Radio>
                        </Radio.Group>
                    </Form.Item>                                         
                   
                    <Form.Item name="yh_state" wrapperCol={{span:10}} required label='状态'>                        
                        <Radio.Group onChange={(e) => {
                            setInfo(prevState=>({...prevState,yh_state:e.target.value}))
                        }}>
                            <Radio value={'1'}>启用</Radio>
                            <Radio value={'2'}>禁用</Radio>
                        </Radio.Group>
                    </Form.Item>    
                    <Form.Item  wrapperCol={{span:16}} label='新增记录'>                        
                        {props.yh_ctime} {props.yh_uname}
                    </Form.Item>
                    <Form.Item  wrapperCol={{span:16}} label='修改记录'>                        
                        {props.yh_update_time} {props.yh_update_uname}
                    </Form.Item>
                    <Form.Item wrapperCol={{offset:6}}>
                        <Icon type='save' onClick={() => { 
                            form
                                .validateFields()
                                .then((values) => {
                                    form.resetFields();
                                    onCreateEdit(values);
                                })
                                .catch((info) => {
                                    // console.log('Validate Failed:', info);
                                });
                            userEdit({
                                "yh_id" : props.user_id,
                                "yh_name" : info.user_name,
                                "yh_phone" : info.yh_phone,
                                "yh_qx" : info.yh_qx,
                                "yh_juese" : '财务',
                                "yh_qy_id" : props.qy_id,
                                "yh_qy_name" : props.qy_name,
                                "yh_state" : info.yh_state,
                                "yh_uid" : props.yh_id,
                                "yh_uname" : props.yh_name,    
                                "yh_update_uname" : props.yh_name,
                            }).then((res) => {
                                // console.log(res);
                                if (res.data.Status === 'success') {
                                    message.success('修改成功')   
                                    setOpen(false)                             
                                }
                                if (res.data.Status === 'fail') {
                                    message.error('修改失败：'+res.data.Message)
                                }
                            })

                        }} />
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}

export default UserEdit